import React, { useEffect, useState } from 'react'

import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import { IconNames } from 'components/icons'
import CheckInSearchBox from 'components/simple-search-box/check-in-search-box'
import ReserveSearchBox from 'components/simple-search-box/my-reservation-search-box'
import Tabs from 'components/tabs'
import e2eClasses from 'constants/e2eClasses'
import FlightStatusSearchBox from 'containers/flight-status/flight-status-search-box'
import { generateHomeRoute } from 'helpers/url/localization'
import { getSearchBoxTab } from 'helpers/url/parseUrl'
import { buildSearchBoxTabs, setArtId } from 'helpers/utils'
import NAMESPACES from 'localization/constants/namespaces'

import { SearchContainer, SearchPanel, TabsContainer, Tab } from './styled'

const SearchBoxContainer = ({
  searchBox,
  selectedTab,
  onTabClick,
  handleReserveError,
  onCheckInNavigation,
  dynamicMargin
}) => {
  const { t, i18n } = useTranslation(NAMESPACES.HOME)
  const {
    location: { search },
    replace
  } = useHistory()

  const [dataTabs, setDataTabs] = useState(null)

  useEffect(() => {
    setDataTabs(buildSearchBoxTabs(i18n.language))
  }, [i18n.language])

  const generatePathSearchBoxTab = (index, language) => ({
    pathname: generateHomeRoute(language),
    search: `?activeTab=${
      Object.entries(buildSearchBoxTabs(language)).find(tab => tab[1].index === index)[1]?.url
    }`
  })

  const onClick = index => {
    replace(generatePathSearchBoxTab(index, i18n.language))
    onTabClick && onTabClick(index)
  }

  const clickOnPanel = index => {
    const url = search.split('?').pop()
    const tab = url && getSearchBoxTab(url, i18n.language)

    if (!search || !tab) {
      replace(generatePathSearchBoxTab(index, i18n.language))
      setArtId(location)
    }
  }

  if (!dataTabs) return <></>

  return (
    <SearchContainer
      e2eClass={e2eClasses.searchBox.container}
      dynamicMargin={dynamicMargin}
      className={'searchBoxContainer'}
    >
      <TabsContainer>
        <Tabs
          selectedTab={selectedTab}
          onTabClick={onClick}
          dataTabs={dataTabs}
          tabs={[
            {
              id: dataTabs.SEARCH_BOX.index,
              icon: IconNames.Airplane,
              tab: <Tab>{t('shopping.search-box-container.flights').toUpperCase()}</Tab>,
              panel: (
                <div onClick={() => clickOnPanel(0)}>
                  <SearchPanel>{searchBox}</SearchPanel>
                </div>
              )
            },
            {
              id: dataTabs.CHECK_IN.index,
              icon: IconNames.BriefcaseCheck,
              tab: <Tab>{t('shopping.search-box-container.check-in').toUpperCase()}</Tab>,
              panel: (
                <div onClick={() => clickOnPanel(1)}>
                  <SearchPanel>
                    <CheckInSearchBox
                      onCheckInNavigation={onCheckInNavigation}
                      onReserveError={handleReserveError}
                    />
                  </SearchPanel>
                </div>
              )
            },
            {
              id: dataTabs.FLIGHT_STATUS.index,
              icon: IconNames.ClockFast,
              tab: <Tab>{t('shopping.search-box-container.flight-status').toUpperCase()}</Tab>,
              panel: (
                <div onClick={() => clickOnPanel(2)}>
                  <SearchPanel>
                    <FlightStatusSearchBox />
                  </SearchPanel>
                </div>
              )
            },
            {
              id: dataTabs.MY_RESERVATION.index,
              icon: IconNames.TagMultiple,
              tab: <Tab>{t('shopping.search-box-container.my-reservation').toUpperCase()}</Tab>,
              panel: (
                <div onClick={() => clickOnPanel(3)}>
                  <SearchPanel>
                    <ReserveSearchBox onReserveError={handleReserveError} />
                  </SearchPanel>
                </div>
              )
            }
          ]}
        />
      </TabsContainer>
    </SearchContainer>
  )
}

export default SearchBoxContainer
